var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"cursive-font ms-2 mb-3 mx-2 black--text"},[_vm._v("Manage your account security")]),_c('div',{staticClass:"d-flex flex-row flex-wrap"},[_c('change-password')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }